export const ROOT = '/';
export const AUTH = '/auth';
export const LOGIN = '/auth/login';
export const HOME = '/';
